<template>
  <div class="about-us-slider-section">
    <slider-wrapper
      :fields="fields"
    />

    <br />
    <br />
    <br />
    <divider
      :is-bold="true"
      :label="fields.sections.value.section_one"
    />
    <div class="main-container">
      <div class="content-wrapper lead-1">
        {{fields.sections.value.section_one_text}}
      </div>
    </div>

    <divider
      :is-bold="true"
      :label="fields.sections.value.section_two"
    />
    <div class="main-container">
      <div class="content-wrapper lead-1"  v-html="fields.sections.value.section_two_text">
      </div>
    </div>
    <divider
      :is-bold="true"
      :label="fields.sections.value.section_three"
    />
    <div class="main-container">
      <div class="content-wrapper lead-1" v-html="fields.sections.value.section_three_text">
      </div>
    </div>
  </div>
</template>

<script>
import SliderWrapper from "/seu-frontend/components/section-fields/Slider";
import Divider from "/seu-frontend/components/section-fields/Divider";

export default {
  name: 'AboutUsSliderSection',
  components: {Divider, SliderWrapper},
  props: {
    fields: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
@import "AboutUsSliderSection.scss";
</style>
